<div class="modal-content pb-3">
  <div class="modal-body px-lg-4 py-lg-4">
    <form [formGroup]="adminHelpdeskFormgroup" (ngSubmit)="onAgentBrokerSelection()">
      <h2 class="model-main-heading mb-1">{{'SelectAgentBroker' | translate}}</h2>
      <p class="first-model mb-0 text-center d-none">
        To navigate to Tours Page kindly find the respective office and Agent/Broker.
      </p>
      <p class="first-model mb-0 text-center">
        To access the Tours Page, please locate the corresponding office and Agent/Broker.
      </p>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="did-floating-label-content mb-3">
            <input class="did-floating-input" type="text" placeholder=" " formControlName="companyName"
              [typeahead]="companynames" (typeaheadOnSelect)="onCompanySelection($event)" typeaheadOptionField="name"
              [typeaheadMinLength]="0" [ngClass]="{
                  'is-invalid': commonService.isControlInvalid(
                    adminHelpdeskFormgroup,
                    'companyName'
                  )
                }" />
            <label class="did-floating-label">{{'Company' | translate}}</label>
            <div *ngIf="
                    commonService.isControlInvalid(
                      adminHelpdeskFormgroup,
                      'companyName'
                    )
                  " class="invalid-feedback">
              <span>{{'Thisfieldisrequired' | translate}}</span>
              <br>
              <span class="error">Select from the list only OR Add a new company from Membership > <a
                  routerLink="/company-offices/Add">Company/Office tab.</a></span>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!isBrokerFieldHidden">
        <div class="col-md-12">
          <div class="did-floating-label-content mb-3">
            <input class="did-floating-input" type="text" placeholder=" " formControlName="brokerName"
              [typeahead]="brokersList" (typeaheadOnSelect)="onBrokerSelection($event)" typeaheadOptionField="name"
              [typeaheadMinLength]="0" [ngClass]="{
                  'is-invalid': commonService.isControlInvalid(
                    adminHelpdeskFormgroup,
                    'brokerName'
                  )
                }" />
            <label class="did-floating-label">{{'Broker' | translate}}</label>

            <div *ngIf="
                commonService.isControlInvalid(
                  adminHelpdeskFormgroup,
                  'brokerName'
                )
              " class="invalid-feedback">
              <span>{{'Thisfieldisrequired' | translate}}</span>
              <br>
              <span class="error">Select from the list only OR Add a new Broker from Membership > <a
                  routerLink="/broker/AddBro">Broker tab</a></span>
            </div>

          </div>
        </div>
      </div>

      <div class="row" *ngIf="!isAgentFieldHidden">
        <div class="col-md-12">
          <div class="did-floating-label-content mb-3">
            <input class="did-floating-input" type="text" placeholder=" " formControlName="agentName"
              [typeahead]="agentList" (typeaheadOnSelect)="onAgentSelection($event)" typeaheadOptionField="name"
              [typeaheadMinLength]="0" />
            <label class="did-floating-label">{{'Agent' | translate}}</label>
          </div>
        </div>
        <!-- <span *ngIf="isAgentErrorMsgVisible && adminHelpdeskFormgroup.get('agentId').touched" class="error">Select from the list only OR Add a new Agent from Membership > <a routerLink="/agent/Add">Agent tab</a></span> -->
      </div>


      <div class="row">
        <div class="col-md-6">
          <button type="button" class="rounded-pill btn continue-btn w-100 mt-2" aria-label="Navigate back"
            routerLink="/dashboard">
            {{'BacktoDashboard' | translate}}
          </button>
        </div>
        <div class="col-md-6">
          <button class="rounded-pill btn save-btn w-100 mt-2" aria-label="Close" type="submit"
            [disabled]="adminHelpdeskFormgroup.invalid">
            {{'ProceedtoCreateListing' | translate}}
          </button>
        </div>

      </div>
    </form>
  </div>
</div>